var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"terms_of_use_link"}},[_c('router-link',{staticClass:" font-koho text-gray-500 text-base sm:text-xs lg:text-sm",attrs:{"to":"/terms_of_use"}},[_vm._v("TERMS OF USE")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }